<template>
  <v-container class="pa-0" fluid>
    <v-row class="pt-13">
      <v-container class="fill-height justify-center flex-column">
        <div class="text-h4 text-sm-h3 font-weight-800 text-center mb-3">MAXQUEST SWEEPS RULES</div>
        <v-row class="justify-center text-h5 ma-2 ma-sm-6 font-weight-bold black--text">
          <div>
            <div class="footerPageCard">
              <p class="normal0" style="line-height: normal; widows: 0; orphans: 0; font-size: 12pt; font-weight: bold">
                <span>VERSION: 1.0</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.15pt;
                  margin-left: 0.6pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                  font-weight: bold;
                "
              >
                <span>DATE UPDATED: May 2, 2024</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 14.35pt;
                  margin-right: 16.35pt;
                  margin-left: 10.8pt;
                  text-indent: 0.9pt;
                  line-height: 108%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  NO PURCHASE OR PAYMENT NECESSARY TO PARTICIPATE. A PURCHASE OR PAYMENT OF ANY KIND WILL NOT INCREASE
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>A PARTICIPANT’S CHANCES OF WINNING.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.5pt;
                  margin-right: 30.8pt;
                  margin-left: 11.2pt;
                  line-height: 109%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  MaxQuest is an online platform that offers participants the chance to play games for entertainment and
                  enjoyment.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  MaxQuest also gives away sweepstakes entries referred to as “Sweeps Coins” as set out in these Sweeps
                  Rules. Sweeps
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Coins can be used to participate in games of promotional play for a chance to win further Sweeps Coins
                  which are redeemable for real prizes.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.4pt;
                  margin-right: 48.8pt;
                  margin-left: 10.85pt;
                  text-indent: 0.3pt;
                  line-height: 109%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  SWEEPS COINS ARE SUBJECT TO A MINIMUM PRIZE REDEMPTION THRESHOLD OF $US150. AMOUNTS BELOW THE
                  THRESHOLD ARE NOT ELIGIBLE FOR PRIZE REDEMPTION.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.3pt;
                  margin-right: 37.5pt;
                  margin-left: 11.15pt;
                  text-indent: -0.3pt;
                  line-height: 109%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  These Sweeps Rules are to be read with the MaxQuest Terms and Conditions. Terms that are defined in
                  the T&amp;Cs have the same meaning in these Sweeps Rules.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.4pt;
                  margin-right: 14.65pt;
                  margin-left: 11.1pt;
                  text-indent: 0.6pt;
                  line-height: 109%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  PLEASE NOTE THAT THESE SWEEPS RULES INCORPORATE CLAUSE 21 OF THE T&amp;Cs, WHICH INCLUDE A PROVISION
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  WAIVING THE RIGHT TO PURSUE ANY CLASS, GROUP OR REPRESENTATIVE CLAIM AND REQUIRING YOU TO PURSUE PAST,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  PENDING AND FUTURE DISPUTES BETWEEN YOU AND MAXQUEST THROUGH INDIVIDUAL ARBITRATION UNLESS YOU OPT-OUT
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>WITHIN THE SPECIFIED TIME FRAME.</span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>1. ELIGIBILITY TO PLAY MAXQUEST</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>1.1.</span>
                <span>The following definitions apply to these Sweeps Rules:</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.75pt;
                  margin-left: 39.25pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>a)</span>
                <span style="font-weight: bold">Eligible Participants</span>
                <span>means legal residents of the Permitted Territories;</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 1.85pt;
                  margin-right: 55.8pt;
                  margin-left: 57.1pt;
                  text-indent: -17.5pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>b)</span>
                <span style="font-weight: bold">Permitted Territories</span>
                <span>means the United States (other than the states of Idaho, Michigan, Montana, and</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>Washington), and Canada (other than the province of Quebec);</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 0.6pt;
                  margin-left: 39.15pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>c)</span>
                <span style="font-weight: bold">Participant</span>
                <span>means a person who participates in Promotional Play;</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 1.75pt;
                  margin-left: 39.15pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>d)</span>
                <span style="font-weight: bold">Promotional Play</span>
                <span>means MaxQuest’s sweepstakes promotions.</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.85pt;
                  margin-right: 30.55pt;
                  margin-left: 36.2pt;
                  text-indent: -36pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>1.2.</span>
                <span>
                  Promotional Play is only open to Eligible participants, who are at least eighteen (18) years old or
                  the age of majority
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  in their jurisdiction (whichever occurs later) at the time of entry. PARTICIPATION IS VOID WHERE
                  PROHIBITED BY LAW.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 36.65pt;
                  margin-left: 35.7pt;
                  text-indent: -35.45pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>1.3.</span>
                <span>
                  The Sweepstakes is subject to all applicable federal, state, provincial, territorial, and local laws
                  and regulations. It is
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  the sole responsibility of a participant to determine whether the Sweepstakes is legal and compliant
                  with all
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>regulations in the jurisdiction in which the participant resides.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.55pt;
                  margin-right: 75.95pt;
                  margin-left: 35.9pt;
                  text-indent: -35.7pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>1.4.</span>
                <span>
                  Participation constitutes the participant’s full and unconditional agreement to these Sweeps Rules and
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Sponsor’s/Promoter’s decisions, which are final and binding in all matters related to the Sweepstakes.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.65pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>1.5.</span>
                <span>
                  Winning a prize is contingent upon fulfilling all requirements set out in these Sweeps Rules.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.75pt;
                  margin-right: 36.35pt;
                  margin-left: 35.7pt;
                  text-indent: -35.45pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>1.6.</span>
                <span>
                  Employees of MaxQuest, any of their respective affiliates, subsidiaries, holding companies,
                  advertising agencies,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  or any other company or individual involved with the design, production, execution, or distribution of
                  the
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Sweepstakes and their immediate family (spouse, parents, siblings, and children, whether the
                  relationship is by
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  birth, marriage or adoption) and household members (people who share the same residence at least 3
                  months of
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>the year) are not eligible to participate.</span>
                <span></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.3pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>2. SPONSOR/PROMOTER</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 9pt;
                  margin-right: 31.35pt;
                  margin-left: 35.95pt;
                  text-indent: -0.35pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>The</span>
                <span style="font-weight: bold">Sponsor/Promoter</span>
                <span>
                  of the Sweepstakes is MQ Technology DWC-LLC - MQ Technology DWC-LLC, Registration No. 10641,
                  registered at Dubai South Business Center, Building C, 3rd Floor, Dubai Logistic City, PO BOX 390667,
                  Dubai, U.A.E.
                </span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-left: 0.05pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>3. HOW TO COLLECT SWEEPS COINS</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 32.1pt;
                  margin-left: 35.6pt;
                  text-indent: -35.4pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.1.</span>
                <span>
                  To participate, you must have an active MaxQuest Account. If you do not have a MaxQuest Account, you
                  can create
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  one free of charge at www.maxquest.com. To enter the Sweepstakes, a participant must access MaxQuest
                  at
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <a href="www.maxquest.com" style="text-decoration: underline; color: var(--v-gold-base)">
                  www.maxquest.com
                </a>
                <span>and sign into their account.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 39.8pt;
                  margin-left: 35.95pt;
                  text-indent: -35.75pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="-aw-import: ignore">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 39.8pt;
                  margin-left: 35.95pt;
                  text-indent: -35.75pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.2.</span>
                <span>
                  Once they have accessed MaxQuest, there are four potential ways for an eligible participant to collect
                  Sweeps
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>Coins:</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.35pt;
                  margin-right: 30pt;
                  margin-left: 36.4pt;
                  line-height: 101%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(a)</span>
                <span style="font-weight: bold">Receive Sweeps Coins as a free bonus when purchasing Quest Coins.</span>
                <span>Each participant may receive</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Sweeps Coins (referred to as Max Coins) as a bonus upon the purchase of specifically marked packs of
                  Quest Coins. Quest Coins can be used for social gameplay in MaxQuest. Quest Coins cannot be redeemed
                  for prizes. The number of Max Coins a participant will receive as a bonus for each relevant Quest Coin
                  purchase will be stated in the Cashier. All purchases of Quest Coins are final and no refunds will be
                  given.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.2pt;
                  margin-right: 31.6pt;
                  margin-left: 71.1pt;
                  text-indent: -34.7pt;
                  line-height: 101%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(b)</span>
                <span style="font-weight: bold">
                  Receive Sweeps Coins when entering Sweeps Coins no-cost giveaway contests.
                </span>
                <span>
                  The Sponsor/Promoter regularly holds Sweeps Coins no-cost giveaway contests which participants can
                  enter by following the instructions provided in the contest. These giveaways may require sharing
                  social media posts or answering various game related questions to be eligible for entry.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  The amount of Sweeps Coins given away will be stated on the applicable Sweeps Coins no-cost contest
                  post and will be added to each contest winner’s Customer Account.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.35pt;
                  margin-right: 42.1pt;
                  margin-left: 71.45pt;
                  text-indent: -35pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(c)</span>
                <span style="font-weight: bold">Receive Sweeps Coins by logging into your account.</span>
                <span>
                  Participants can receive eligible Sweeps Coins on a daily basis by taking the following steps to
                  collect the
                </span>
                <span style="font-weight: bold">Daily Bonus</span>
                <span>:</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.5pt;
                  margin-left: 86.85pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>i. signing into their Customer Account;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.35pt;
                  margin-left: 84.7pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>ii. clicking on the “Get Coins” button on the lobby page;</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.1pt;
                  margin-right: 32.7pt;
                  margin-left: 82.55pt;
                  line-height: 103%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  iii. if the Customer Account has not previously been verified, clicking on the “Verify your Account to
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>unlock” link and having the Customer Account verified to our satisfaction; and</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.1pt;
                  margin-left: 82.55pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>iv. clicking on the “Claim your FREE daily prize coins” button.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 12.2pt;
                  margin-right: 30.25pt;
                  margin-left: 71.45pt;
                  text-indent: 0.5pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  Participants can only claim a Daily Bonus once per day (the daily clock resets every 24 hours). The
                  amount of Sweeps Coins available to a participant to claim as a Daily Bonus on any day is displayed in
                  their Customer Account. These coins are only awarded to the customer account at a 2:1 payback ratio
                  for PVP prize multiplier.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 12.05pt;
                  margin-right: 49.6pt;
                  margin-left: 36.4pt;
                  line-height: 101%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(d)</span>
                <span style="font-weight: bold">Receive Sweeps Coins by sending a request by post.</span>
                <span>
                  Participants can receive free Sweeps Coins by sending a standard postcard or piece of white paper (
                </span>
                <span style="font-weight: bold">Request Card</span>
                <span>
                  ) which must be 4” x 6”, unfolded, blank, and unlined, and placed inside a stamped #10 envelope
                  addressed in handwriting to the following address and satisfying the requirements set out below:
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-left: 86.95pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>i. United States residents:</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-left: 86.95pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>PO Box #276</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-left: 86.95pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>167 Lamp and Lantern Village</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-left: 86.95pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>Chesterfield, MO 63017.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 0.3pt;
                  margin-left: 108.8pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="font-weight: bold; -aw-import: ignore">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 0.3pt;
                  margin-left: 108.8pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="font-weight: bold; -aw-import: ignore">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="margin-top: 10.4pt; line-height: normal; widows: 0; orphans: 0; font-size: 12pt"
              >
                <span>Participants</span>
                <span>must:</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.3pt;
                  margin-right: 60.1pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  i. handwrite their return address on the front of the envelope and the words: “Sweepstakes Entries”;
                  and
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.15pt;
                  margin-right: 66.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>ii. handwrite all of the following</span>
                <span style="font-weight: bold">on only one side of the Request Card</span>
                <span>inserted inside the envelope</span>
                <span style="font-weight: bold">:</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.5pt;
                  margin-right: 95.7pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>• their full name as shown on their government issued identification;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.4pt;
                  margin-right: 129pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>• the email address and username registered to their MaxQuest account;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 11.1pt;
                  margin-right: 64.95pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>• the return residential address registered to their MaxQuest account; and</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 11.1pt;
                  margin-right: 64.95pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>• the following statement:</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.25pt;
                  margin-right: 103.3pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  “I wish to receive Sweeps Coins to participate in the sweepstakes promotions offered by MaxQuest. By
                  submitting this request, I hereby declare that I have read, understood, and agree to be bound by
                  MaxQuest Terms and Conditions and Sweeps Rules.”
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.2pt;
                  margin-right: 43.6pt;
                  line-height: 103%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>iii.</span>
                <span style="font-weight: bold">
                  FOR THE AVOIDANCE OF DOUBT, COMBINED REQUESTS SENT VIA PACKAGE OR PARCEL
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">DO NOT MEET THE REQUIREMENTS SET OUT ABOVE AND ARE INVALID.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.1pt;
                  margin-right: 31.25pt;
                  margin-left: 35.55pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  3.3. There is a limit of one Request Card per outer envelope. For each Request Card a participant
                  submits in accordance with the above requirements, the participant will receive 1 Sweeps Coin. The
                  Sweeps Coins will be added to the participant’s Customer Account.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.1pt;
                  margin-right: 31.25pt;
                  margin-left: 35.55pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="font-weight: bold">
                  NOTE: A Participant must ensure that their handwriting is legible.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.1pt;
                  margin-right: 31.25pt;
                  margin-left: 35.55pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  If the participant’s handwriting is not legible, the entry will be void and the Sweeps Coins will not
                  be added to the participant’s Customer Account. The legibility of a participant’s handwriting will be
                  determined by the Sponsor/Promoter in its sole discretion.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.1pt;
                  margin-right: 31.25pt;
                  margin-left: 35.55pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="font-weight: bold">
                  THE REQUEST MUST ONLY BE MADE BY THE PARTICIPANT AND MUST BE POSTED FROM THE SAME STATE OR PROVINCE AS
                  THE PARTICIPANT’S VERIFIED RESIDENTIAL ADDRESS
                </span>
                <span>.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  Requests made by any other individual or any entity (including but not limited to commercial
                  sweepstakes subscription notification and/or entering services) or posted from a state or province
                  different to the participant’s verified residential address will be declared invalid and Sweeps Coins
                  will not be added to the participant’s Customer Account. Tampering with the entry process or the
                  operation of the Sweepstakes,
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  including but not limited to the use of any device or software to automate the Sweeps Coins
                  request/entry process or to unfairly assist the participant with meeting the handwriting requirement,
                  is prohibited and any requests/entries deemed by Sponsor/Promoter, in its sole discretion, to have
                  been submitted in this manner will be void. Where there is an issue or fault with an envelope used by
                  a participant to request free Sweeps
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  Coins, such that it does, or is reasonably likely to, cause damage to, or otherwise adversely affect,
                  equipment used or procedures implemented to process mailed in requests (for example, handmade
                  envelopes that are not suitable for machine processing due to poor quality or non-standard adhesive or
                  paper), such entry will be void. In the event a dispute regarding the identity of the individual who
                  actually submitted a request or whether a request satisfies the requirements set out above cannot be
                  resolved to the Sponsor/Promoter’s satisfaction, the affected request/entry will be deemed ineligible.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 12.3pt;
                  margin-right: 39.75pt;
                  margin-left: 36pt;
                  text-indent: -35.75pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.6.</span>
                <span>
                  The amount of Sweeps Coins a participant has will be displayed in their Customer Account on the
                  website. The
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  amount of Sweeps Coins to be allocated to participants can be changed at any time by the
                  Sponsor/Promoter in
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>its sole discretion.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 39.9pt;
                  margin-left: 36.35pt;
                  text-indent: -36.1pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.7.</span>
                <span>
                  Sponsor/Promoter is not responsible for lost, late, incomplete, invalid, unintelligible, or
                  misdirected Sweeps Coins
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>requests or allocations</span>
                <span>.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 35.6pt;
                  margin-left: 35.9pt;
                  text-indent: -35.7pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.8.</span>
                <span>
                  In the event of a dispute as to any registration of a Customer Account, the authorized account holder
                  of the email
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  address used to register the Customer Account will be deemed to be the participant. The “authorized
                  account
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  holder” is the natural person assigned the email address by an internet access provider, online
                  service provider, or
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  other organization responsible for assigning email addresses for the domain associated with the
                  submitted
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>address.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-right: 41.9pt;
                  margin-left: 36pt;
                  text-indent: -35.75pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.9.</span>
                <span>
                  Use of any automated or other system(s) to participate, to acquire Sweeps Coins, or play the games is
                  prohibited
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>and will result in disqualification and loss of eligibility to participate in the games.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 57.65pt;
                  margin-left: 35.55pt;
                  text-indent: -35.35pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.10.</span>
                <span>
                  Sweeps Coins are only valid for ninety (30) days from the date a participant last logged on to their
                  Customer
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>Account and will then automatically expire.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 71.6pt;
                  margin-left: 35.9pt;
                  text-indent: -35.7pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>3.11.</span>
                <span>
                  Sweeps Coins may also be forfeited if a participant’s Customer Account is closed for any reason, or at
                  the
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>Sponsor/Promoter’s discretion.</span>
                <span></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.4pt;
                  margin-left: 0.6pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>4. USING SWEEPS COINS TO PLAY GAMES</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 9pt;
                  margin-right: 30.9pt;
                  margin-left: 0.45pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.1.</span>
                <span>Participants with Sweeps Coins can use those Sweeps Coins to play games within</span>
                <span>MaxQuest</span>
                <span>
                  for a chance to win additional Sweeps Coins. Sweeps Coins won through gameplay can be redeemed for
                  real prizes.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 34.9pt;
                  margin-left: 35.6pt;
                  text-indent: -35.15pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.2.</span>
                <span>Within</span>
                <span>MaxQuest</span>
                <span>
                  there are different games. The amount of Sweeps Coins required to play each game will be detailed next
                  to the game. A participant may be able to increase the amount of Sweeps Coins they play the game with
                  so they can increase their potential winning eligibility.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 37.4pt;
                  margin-left: 35.9pt;
                  text-indent: -35.45pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.3.</span>
                <span>
                  Only games played with Sweeps Coins provide the opportunity to redeem winnings for real prizes. The
                  prize that can be won while playing a game will be shown in
                </span>
                <span>MaxQuest</span>
                <span>by clicking the “Win Table” or “Pay Table” button,</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>denominated as “Sweeps Coins”.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 53.1pt;
                  margin-left: 35.9pt;
                  text-indent: -35.45pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.4.</span>
                <span>
                  Each Sweeps Coin that has been won through gameplay (rather than collected using one of the methods
                  described in clause 3 of these Sweeps Rules can be redeemed for a prize with a value being equivalent
                  to US$1.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-right: 51.65pt;
                  margin-left: 36pt;
                  text-indent: -35.5pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.5.</span>
                <span>
                  Sponsor’s/Promoter’s decisions as to the administration and operation of the Sweepstakes, the game,
                  and the amount of winnings are final and binding.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.4pt;
                  margin-right: 30.65pt;
                  margin-left: 0.45pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.6.</span>
                <span>
                  Unless the Sponsor/Promoter requires otherwise, any Sweeps Coins allocated to a participant are
                  required to be
                </span>
                <span></span>
                <span>
                  played once before they are eligible to be redeemed for prizes. Sponsor/Promoter may, in its sole
                  discretion,
                </span>
                <span>
                  require that any Sweeps Coins allocated to a participant must be played a greater number of times (not
                  exceeding
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>20) in any</span>
                <span>combination of Sweeps Coins games before they are eligible to be redeemed for prizes.</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 30.05pt;
                  margin-left: 0.45pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>4.7.</span>
                <span>
                  Sponsor/Promoter reserves the right to change the prize win rates and odds of any of the Promotional
                  Play Games
                </span>
                <span></span>
                <span>
                  at any time. A participant can see the actual and any amended details by clicking on the “Win
                </span>
                <span>Table” or “Pay Table”</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  button. It is a participant’s responsibility to check the prize win rate on each occasion before they
                  participate.
                </span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>5. VERIFICATION AND CONFIRMATION OF POTENTIAL WINNERS</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 35.4pt;
                  margin-left: 35.5pt;
                  text-indent: -35.15pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>5.1.</span>
                <span style="font-weight: bold">POTENTIAL</span>
                <span style="font-weight: bold">
                  SWEEPSTAKES WINNERS ARE SUBJECT TO VERIFICATION BY SPONSOR/PROMOTER (IN ANY
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  MANNER IT MAY CHOOSE) AND THE DECISIONS OF SPONSOR/PROMOTER ARE FINAL AND BINDING IN ALL
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  MATTERS RELATED TO THE SWEEPSTAKES. A PARTICIPANT IS NOT A WINNER OF ANY PRIZE, EVEN IF THE
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  ONLINE SCREEN INDICATES THEY ARE, UNLESS AND UNTIL THE PARTICIPANT’S ELIGIBILITY AND THE
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  POTENTIAL WINNING PLAY HAS BEEN VERIFIED AND THE PARTICIPANT HAS FULLY COMPLIED WITH THESE
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  SWEEPS RULES AND BEEN NOTIFIED THAT VERIFICATION IS COMPLETE. SPONSOR/PROMOTER WILL NOT
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  ACCEPT SCREENSHOTS OR OTHER PURPORTED EVIDENCE OF WINNING IN LIEU OF ITS VALIDATION
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">PROCESS.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 63.6pt;
                  margin-left: 36.35pt;
                  text-indent: -36pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>5.2.</span>
                <span>
                  Potential prize winners must comply with these Sweeps Rules and winning is contingent upon fulfilling
                  all requirements.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.4pt;
                  margin-right: 32.8pt;
                  margin-left: 0.3pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>5.3.</span>
                <span>
                  A potential prize winner may be required to sign and return to the Sponsor/Promoter, an
                  affidavit/declaration of
                </span>
                <span></span>
                <span>
                  eligibility, and liability/publicity release (except where prohibited) in order to claim his/her prize
                  (if applicable). In
                </span>
                <span></span>
                <span>
                  addition, in the case of a Canadian eligible winner, he/she will be required to correctly answer a
                  mathematical skill testing question without mechanical or other aid to be administered at a
                  pre-arranged mutually convenient time.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 32.8pt;
                  margin-left: 35.7pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>5.4.</span>
                <span>
                  If a potential winner cannot be contacted, fails to properly execute and return the
                  affidavit/declaration of eligibility and liability/publicity release within the required time period
                  (if applicable), fails to comply with these Sweeps
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Rules (including, but not limited to, the requirement to correctly answer the mathematical
                  skill-testing question if a resident of Canada), or if the prize or prize notification is returned as
                  undeliverable, that potential winner forfeits the prize.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 29.75pt;
                  margin-left: 36.2pt;
                  text-indent: -35.9pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>5.5.</span>
                <span>
                  In the event that a potential winner of a Sweepstakes prize is disqualified for any reason, the
                  Sponsor/Promoter may, in its sole discretion, reseed the prize back into the Sweepstakes.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.3pt;
                  margin-left: 0.45pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>6. PRIZES</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-left: 0.55pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.1.</span>
                <span>A Participant’s Sweeps Coins balance is shown in the participant’s Customer Account.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.85pt;
                  margin-left: 0.55pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.2.</span>
                <span>
                  Prizes are not awarded until redeemed. A participant has no rights to Sweeps Coins that have not been
                  redeemed.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.75pt;
                  margin-right: 52.6pt;
                  margin-left: 36pt;
                  text-indent: -35.4pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.3.</span>
                <span>
                  Where a participant has chosen to redeem prizes for cash, the payment will be made in USD to the
                  financial account or online wallet from which you purchased Quest Coins, or if this is not technically
                  possible, then to an alternative bank account you nominate. Sponsor/Promoter reserves the right to
                  require the use of the same payment method for redemption of prizes as was used to purchase Quest
                  Coins, or a specific payment method at
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>Sponsor/Promoter's discretion.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 31.75pt;
                  margin-left: 35.7pt;
                  text-indent: -35.1pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.4.</span>
                <span>
                  Where a participant has chosen to redeem prizes for gift cards, the gift cards will be allocated to
                  the email address that the participant has registered against their Customer Account.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 32.7pt;
                  margin-left: 36.35pt;
                  text-indent: -35.8pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.5.</span>
                <span>
                  Sponsor/Promoter will only process a prize redemption if the redeemed value of the prize is US$150 or
                  more (i.e. a minimum of 150 eligible Sweeps Coins). Consequently, a participant’s Customer Account
                  must have a balance of at least 150 Sweeps Coins before requesting a prize redemption.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-left: 0.55pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.6.</span>
                <span>TO BE ELIGIBLE FOR A SWEEPS COINS PRIZE OR A SWEEPS COINS PRIZE REDEMPTION:</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 11.7pt;
                  margin-left: 37pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(a)</span>
                <span>A PARTICIPANT MUST BE AN ELIGIBLE PARTICIPANT; AND</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.4pt;
                  margin-left: 37pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(b)</span>
                <span>THE PARTICIPANT’S DETAILS MUST MATCH THOSE OF THE PARTICIPANT’S CUSTOMER ACCOUNT.</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 31.9pt;
                  margin-left: 36pt;
                  text-indent: -35.4pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.7.</span>
                <span>
                  In New York and Florida, the maximum redemption value of a Sweeps Coins prize won on any one spin or
                  play, via a participant’s participation in the Promotional Play Games is US$5,000. Any prize valued in
                  excess of US$5,000 will
                </span>
                <span></span>
                <span>be reduced to a maximum value of US$5,000.</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 31.2pt;
                  margin-left: 35.6pt;
                  text-indent: -35.05pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.8.</span>
                <span>
                  Sponsor/Promoter reserves the right, in its sole discretion, to limit a participant’s redemption of
                  Sweeps Coins to
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  US$10,000 per day or any other amount over any time that Sponsor/Promoter considers necessary to
                  satisfy its regulatory obligations or the requirements of its partners and suppliers. No more than the
                  stated number of prizes will be awarded.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.55pt;
                  margin-right: 51.1pt;
                  margin-left: 0.55pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.9.</span>
                <span>
                  Sponsor/Promoter is not responsible for any taxes or fees associated with a prize redemption.
                  Participants are responsible for all applicable taxes and fees associated with prize receipt and/or
                  redemption.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.6pt;
                  margin-right: 35.55pt;
                  margin-left: 35.9pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.10.</span>
                <span>
                  Sponsor/Promoter is not responsible for any foreign exchange transaction fees, charges, or related
                  costs that may be incurred as a result of, or in relation to, a prize redemption, including but not
                  limited to any losses or additional costs arising from foreign exchange fluctuations.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 34.15pt;
                  margin-left: 35.9pt;
                  text-indent: -35.35pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.11.</span>
                <span>
                  Sweep coins are not transferable and no substitution will be made except as provided herein at the
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Sponsor’s/Promoter’s sole discretion. Sponsor/Promoter reserves the right to substitute the listed
                  prize of equal or greater value for any reason owing to circumstances outside the Sponsor’s/Promoter’s
                  reasonable control.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-left: 0.55pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>6.12.</span>
                <span>Prize winners will be notified by private message or email.</span>
                <span></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 7.75pt;
                  margin-left: 0.35pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>7. ENTRY CONDITIONS AND RELEASE</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-left: 36.45pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>By participating, each participant agrees to:</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 11.75pt;
                  margin-left: 37pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(a)</span>
                <span>comply with and be bound by:</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.4pt;
                  margin-left: 86.35pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>i.</span>
                <span>the T&amp;Cs;</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.05pt;
                  margin-left: 84.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>ii.</span>
                <span>these Sweeps Rules; and</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.05pt;
                  margin-left: 82.05pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>iii.</span>
                <span>the decisions of the Sponsor/Promoter which are binding and final;</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.4pt;
                  margin-right: 33.25pt;
                  margin-left: 36.4pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(b)</span>
                <span>
                  release and hold harmless the Sponsor/Promoter and its parent, subsidiary, and affiliated companies,
                  the
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  prize suppliers, and any other organizations responsible for sponsoring, fulfilling, administering,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 0.4pt;
                  margin-right: 35.25pt;
                  margin-left: 72.5pt;
                  text-indent: 0.05pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  advertising or promoting the Sweepstakes, and all of their respective past and present officers,
                  directors,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>employees, agents, and representatives (collectively, the</span>
                <span style="font-weight: bold">Released Parties</span>
                <span>) from and against any and all</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  claims, expenses, and liability, including but not limited to negligence and damages of any kind to
                  persons and property, including but not limited to invasion of privacy (under the appropriation,
                  intrusion,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  public disclosure of private facts, false light in the public eye or other legal theory), defamation,
                  slander,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  libel, violation of the right of publicity, infringement of trademark, copyright or other intellectual
                  property
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  rights, property damage, or death or personal injury arising out of or relating to a participant’s
                  entry,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  creation of an entry or submission of an entry, participation in the Sweepstakes, acceptance or use or
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  misuse of prizes (including any travel or activity related thereto) and/or the broadcast, exploitation
                  or use
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>of entry; and</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.3pt;
                  margin-right: 64.85pt;
                  margin-left: 72.5pt;
                  text-indent: -35.5pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(c)</span>
                <span>
                  indemnify, defend, and hold harmless the Sponsor/Promoter from and against any and all claims,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  expenses, and liabilities (including reasonable attorneys/legal fees) arising out of or relating to a
                  participant’s participation in the Sweepstakes and/or participant’s acceptance, use or misuse of
                  prizes.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.3pt;
                  margin-right: 64.85pt;
                  margin-left: 72.5pt;
                  text-indent: -35.5pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="-aw-import: ignore">&#xa0;</span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 0.25pt;
                  margin-right: 45.45pt;
                  margin-left: 0.4pt;
                  line-height: 202%;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>8. PUBLICITY</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 1.3pt;
                  margin-right: 60.2pt;
                  margin-left: 35.9pt;
                  text-indent: 0.5pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>
                  Except where prohibited, participation in the Sweepstakes constitutes each participant’s consent to
                  the Sponsor’s/Promoter’s and its agent’s use of the participant’s name, likeness, photograph, voice,
                  opinions, and/or hometown and state/province/territory for promotional purposes in any media,
                  worldwide, without further payment, notice or consideration.
                </span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 1.3pt;
                  margin-right: 60.2pt;
                  margin-left: 35.9pt;
                  text-indent: 0.5pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="-aw-import: ignore">&#xa0;</span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-left: 0.25pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>9. GENERAL CONDITIONS</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 33.4pt;
                  margin-left: 35.7pt;
                  text-indent: -35.3pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>9.1.</span>
                <span>
                  Sponsor/Promoter reserves the right to cancel, suspend and/or modify the Sweepstakes or these Sweeps
                  Rules, or any part of the Sweepstakes or these Sweeps Rules, with immediate effect owing to
                  circumstances outside its reasonable control and only where circumstances make it unavoidable if any
                  fraud, technical failures or any other factor beyond Sponsor’s/Promoter’s reasonable control impairs
                  the integrity or proper functioning of the
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>Sweepstakes, as determined by Sponsor/Promoter in its sole discretion.</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 36pt;
                  margin-left: 35.7pt;
                  text-indent: -35.3pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>9.2.</span>
                <span>
                  Sponsor/Promoter reserves the right in its sole discretion to disqualify any individual it finds to be
                  tampering with the entry process or the operation of the Sweepstakes or to be acting in violation of
                  these Sweeps Rules or any other promotion or in an unsportsmanlike or disruptive manner.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.55pt;
                  margin-right: 31.3pt;
                  margin-left: 35.55pt;
                  text-indent: -35.15pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>9.3.</span>
                <span>
                  Any attempt by any person to deliberately undermine the legitimate operation of the Sweepstakes may be
                  a violation of criminal and civil law and, should such an attempt be made, Sponsor/Promoter reserves
                  the right to seek damages from any such person to the fullest extent permitted by law. The
                  Sponsor’s/Promoter’s failure to enforce any term of these Sweeps Rules shall not constitute a waiver
                  of that provision.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 31.95pt;
                  margin-left: 0.35pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>9.4.</span>
                <span>
                  In all other cases, the Sponsor/Promoter reserves the right to cancel, suspend, and/or modify the
                  Sweepstakes. Any
                </span>
                <span style="-aw-import: spaces">&#xa0;&#xa0;</span>
                <span>notice regarding cancellation, suspension, and/or modification will be posted on</span>
                <span>MaxQuest</span>
                <span>at</span>
                <a href="www.maxquest.com" style="text-decoration: underline; color: var(--v-gold-base)">
                  www.maxquest.com
                </a>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 7.85pt;
                  margin-right: 37.75pt;
                  margin-left: 35.9pt;
                  text-indent: -35.5pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>9.5.</span>
                <span>
                  Whenever we amend these Sweeps Rules in a way that would limit your current rights or which may be to
                  your detriment, we will notify you upon your next visit to the Platform and you will be required to
                  re-confirm your acceptance prior to participating in any Promotional Play. If you do not agree to the
                  amended Sweeps Rules, you may not participate in any Promotional Play.
                </span>
                <span></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>10. LIMITATIONS OF LIABILITY</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 30.75pt;
                  margin-left: 35.7pt;
                  text-indent: -35.45pt;
                  line-height: 115%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>10.1.</span>
                <span>
                  Insofar as permitted by law in the respective territories, the Released Parties (as defined above) are
                  not responsible
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>for:</span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.45pt;
                  margin-right: 39.55pt;
                  margin-left: 72.5pt;
                  text-indent: -35.5pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(a)</span>
                <span>
                  any incorrect or inaccurate information, whether caused by a participant, printing error or by any of
                  the
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>equipment or programming associated with or utilized in the Sweepstakes;</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.35pt;
                  margin-right: 35.4pt;
                  margin-left: 72.8pt;
                  text-indent: -35.8pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(b)</span>
                <span>
                  technical failures of any kind, including, but not limited to malfunctions, interruptions, or
                  disconnections
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>in phone lines or network hardware or software;</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.35pt;
                  margin-left: 37pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(c)</span>
                <span>unauthorized human intervention in any part of the entry process or the Sweepstakes;</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.4pt;
                  margin-left: 37pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(d)</span>
                <span>
                  technical or human error which may occur in the administration or operation of the Sweepstakes; or
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.3pt;
                  margin-right: 45.35pt;
                  margin-left: 37pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>(e)</span>
                <span>
                  any injury or damage to persons or property which may be caused, directly or indirectly, in whole or
                  in part, from the participant’s participation in the Sweepstakes or receipt or use or misuse of any
                  prize.
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 10.2pt;
                  margin-right: 36.55pt;
                  margin-left: 35.9pt;
                  text-indent: -35.7pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>10.2.</span>
                <span>
                  If for any reason a Participant’s Sweeps Coins or winning play is confirmed to have been erroneously
                  deleted, lost,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  or otherwise destroyed or corrupted, the participant’s sole remedy is replacement by Sponsor/Promotor
                  of an equivalent amount of Sweeps Coins.
                </span>
                <span></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.35pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>11. DISPUTES</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 29.35pt;
                  margin-left: 35.55pt;
                  text-indent: 0.3pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="font-weight: bold">Clause 24 of the</span>
                <a href="/tnc" style="font-weight: bold; text-decoration: underline; color: var(--v-gold-base)">
                  T&amp;Cs
                </a>
                <span style="font-weight: bold">
                  (Dispute Resolution and Agreement to Arbitrate on an Individual Basis) is incorporated herein by
                  reference with the same force and effect as though fully set forth herein. By agreeing to these
                </span>
                <span style="font-weight: bold; -aw-import: spaces">&#xa0;</span>
                <span style="font-weight: bold">
                  Sweeps Rules, you agree to be bound by the dispute resolution and arbitration provisions contained in
                  clause
                </span>
                <span style="font-weight: bold"></span>
                <span style="font-weight: bold">21 of the T&amp;Cs.</span>
                <span style="font-weight: bold"></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.3pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>12. OTHER</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 37.95pt;
                  margin-left: 35.5pt;
                  text-indent: -35.3pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>12.1.</span>
                <span>
                  Under no circumstances will any participant be permitted to obtain awards for, and the participant
                  hereby waives all rights to claim, punitive, incidental, or consequential damages, or any other
                  damages, including attorneys’ fees,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  other than the participant’s actual out-of-pocket expenses (i.e., costs associated with participating
                  in this
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Sweepstakes), and participant further waives all rights to have damages multiplied or increased. SOME
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>J</span>
                <span>URISDICTIONS DO NOT ALLOW THE LIMITATIONS OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR</span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>CONSEQUENTIAL DAMAGES, SO THE ABOVE MAY NOT APPLY TO YOU.</span>
                <span style="-aw-import: spaces">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 29.4pt;
                  margin-left: 35.7pt;
                  text-indent: -35.45pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>12.2.</span>
                <span>
                  All issues and questions concerning the construction, validity, interpretation, and enforceability of
                  these Sweeps
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  Rules, or the rights and obligations of the participant and Sponsor/Promoter in connection with the
                  Sweepstakes,
                </span>
                <span style="-aw-import: spaces">&#xa0;</span>
                <span>
                  are governed by, and construed in accordance with, the laws of the State of Delaware, without giving
                  effect to any choice of law or conflict of law rules (whether of the State of Delaware or any other
                  jurisdiction), which would cause the application of the laws of any jurisdiction other than the State
                  of Delaware.
                </span>
                <span></span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 50.25pt;
                  margin-left: 35.9pt;
                  text-indent: -35.7pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>12.3.</span>
                <span>To</span>
                <span>
                  ensure fairness and the integrity of the promotion to all participants, the Sponsor/Promoter will
                  respond to questions to Customer Support via this
                </span>
                <a href="/contact" style="text-decoration: underline; color: var(--v-gold-base)">form</a>
                <span>and may post updates/communications on its Facebook page.</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 6.45pt;
                  margin-right: 50.25pt;
                  margin-left: 35.9pt;
                  text-indent: -35.7pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span style="-aw-import: ignore">&#xa0;</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-right: 38.3pt;
                  margin-left: 0.2pt;
                  line-height: 116%;
                  widows: 0;
                  orphans: 0;
                  font-size: 12pt;
                "
              >
                <span>12.4.</span>
                <span>
                  Any participant posting or seen to be posting comments on the Sponsor’s/Promoter’s social media pages
                  or elsewhere during the promotion that is considered bullying, spiteful, or upsetting to other
                  participants, players, and fans of
                </span>
                <span></span>
                <span>
                  MaxQuet or directly aimed at the Sponsor/Promoter, will have their comments removed and will be
                  disqualified from the Sweepstakes. The Sponsor/Promoter reserves the right to alert Facebook to any
                  such behavior and the participant may have his/her Facebook account frozen pending investigation.
                </span>
                <span></span>
              </p>
            </div>

            <div class="footerPageCard">
              <p
                class="normal0"
                style="
                  margin-top: 6.3pt;
                  margin-left: 0.2pt;
                  line-height: normal;
                  widows: 0;
                  orphans: 0;
                  font-size: 16pt;
                  font-weight: bold;
                "
              >
                <span>13. PARTICIPANT’S PERSONAL INFORMATION</span>
              </p>
              <p
                class="normal0"
                style="
                  margin-top: 8.9pt;
                  margin-right: 38.1pt;
                  margin-left: 35.6pt;
                  text-indent: -35.4pt;
                  line-height: 117%;
                  widows: 0;
                  orphans: 0;
                "
              >
                <span style="line-height: 117%; font-size: 12pt">13.1.</span>
                <span style="line-height: 117%; font-size: 12pt">
                  Information collected from participants is subject to the Sponsor’s/Promoter’s
                </span>
                <a
                  href="/privacypolicy"
                  style="
                    line-height: 117%;

                    font-size: 12pt;
                    text-decoration: underline;
                    color: var(--v-gold-base);
                  "
                >
                  Privacy Policy
                </a>
                <span
                  style="
                    line-height: 117%;

                    font-size: 12pt;
                  "
                >
                  which is available at
                </span>
                <span
                  style="
                    line-height: 117%;

                    font-size: 12pt;
                    -aw-import: spaces;
                  "
                >
                  &#xa0;
                </span>
                <a href="http://www.maxquest.com" style="text-decoration: none">
                  <span
                    style="
                      line-height: 117%;

                      font-size: 12pt;
                      text-decoration: underline;
                      color: var(--v-gold-base);
                    "
                  >
                    www.
                  </span>
                </a>
                <a href="http://www.maxquest.com" style="text-decoration: none">
                  <span
                    style="
                      line-height: 117%;

                      font-size: 12pt;
                      text-decoration: underline;
                      color: var(--v-gold-base);
                    "
                  >
                    maxquest.
                  </span>
                </a>
                <a href="http://www.maxquest.com" style="text-decoration: none">
                  <span
                    style="
                      line-height: 117%;

                      font-size: 12pt;
                      text-decoration: underline;
                      color: var(--v-gold-base);
                    "
                  >
                    com
                  </span>
                </a>
                <span
                  style="
                    line-height: 117%;

                    font-size: 12pt;
                  "
                >
                  .
                </span>
              </p>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'SweepRules',

    metaInfo() {
      return {
        title: 'Sweeps Rules',
        meta: [
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ],
      };
    },
  };
</script>
<style lang="scss" scoped>
  table {
    margin-top: 20px;
    width: 100%;
    border-collapse: collapse;
    border: 1px solid white;
  }

  th,
  td {
    text-align: left;
    padding: 8px;
    border: 1px solid white;
  }

  .footer-gradient-bg {
    background: linear-gradient(180deg, #583f76, #8171af);
  }

  .sec1-lg {
    background: linear-gradient(45deg, #544aa0, #0894ab);
    padding: 80px 0;
    min-height: 144px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .v-card__title {
    font-size: 22px;
    margin-bottom: 20px;
    font-weight: 800;
    text-transform: uppercase;
    padding: 0 !important;
  }

  .v-card__text {
    padding: 0 !important;
    font-size: 18px;
    margin-bottom: 24px;
  }

  ol,
  ul {
    font-size: 18px;
    padding-left: 40px;
    margin-bottom: 20px;
    font-weight: 400;
  }

  ol li,
  ul li {
    padding-left: 20px;
    margin-bottom: 5px;

    @media screen and (max-width: 600px) {
      padding-left: 10px;
    }
  }

  ol li a,
  ul li a {
    color: #fff;
    text-decoration: underline;
    overflow-wrap: break-word;
  }

  ol li a:hover,
  ul li a:hover {
    color: #f8bf1e;
    text-decoration: none;
  }

  ul {
    list-style: disc;

    li {
      margin-left: 40px;
    }
  }

  .footerPageCard {
    padding: 28px;
    color: white;
    margin-top: 20px;
  }

  .footerPageCard::before {
    width: 90%;
    max-width: 1200px;
    content: '';
    position: absolute;
    top: 0;
    left: 5%;
  }

  .footerPageCard::after {
    width: 90%;
    max-width: 1200px;
    content: '';
    position: absolute;
    bottom: 0;
    left: 5%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  h1 {
    margin-top: 24pt;
    margin-bottom: 6pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;

    font-size: 24pt;
    font-weight: bold;
    color: #000000;
  }

  h2 {
    margin-top: 18pt;
    margin-bottom: 4pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;

    font-size: 18pt;
    font-weight: bold;
    color: #000000;
  }

  h3 {
    margin-top: 14pt;
    margin-bottom: 4pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;

    font-size: 14pt;
    font-weight: bold;
    color: #000000;
  }

  h4 {
    margin-top: 12pt;
    margin-bottom: 2pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;

    font-size: 16pt;
    font-weight: bold;
    font-style: normal;
    color: #000000;
  }

  h5 {
    margin-top: 11pt;
    margin-bottom: 2pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;

    font-size: 11pt;
    font-weight: bold;
    color: #000000;
  }

  h6 {
    margin-top: 10pt;
    margin-bottom: 2pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;

    font-size: 10pt;
    font-weight: bold;
    color: #000000;
  }

  .Subtitle {
    margin-top: 18pt;
    margin-bottom: 4pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;
    font-size: 24pt;
    font-style: italic;
    color: #666666;
  }

  .Title {
    margin-top: 24pt;
    margin-bottom: 6pt;
    page-break-before: auto;
    page-break-inside: avoid;
    page-break-after: avoid;
    line-height: 115%;
    font-size: 36pt;
    font-weight: bold;
  }

  .normal0 {
    line-height: 115%;
    font-size: 11pt;
    -aw-style-name: 'normal';
  }
</style>
